import { useMutation } from '@tanstack/react-query';
import { API_TAGS } from '@/shared/api';
import { generateTitle, generateCode } from './api';
import { GenerateTitleRequest, GenerateCodeRequest } from './types';

export const contentKeys = {
  all: [API_TAGS.CONTENT] as const,
  generateTitle: () => [...contentKeys.all, 'generateTitle'] as const,
  generateCode: () => [...contentKeys.all, 'generateCode'] as const,
};

export const useGenerateTitle = () => {
  return useMutation({
    mutationFn: (payload: GenerateTitleRequest) => generateTitle(payload),
  });
};

export const useGenerateCode = () => {
  return useMutation({
    mutationFn: (payload: GenerateCodeRequest) => generateCode(payload),
  });
};
